export const getStyles = (theme) => ({
  container: {
    marginTop: '-30px',
  },
  modal: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingTop: "60px",
    zIndex: 1000,
    overflowY: "auto",
  },
  modalContent: {
    background: theme === "light" ? "#ffffff" : "#1e293b",
    borderRadius: "20px",
    padding: "36px",
    width: "90%",
    maxWidth: "500px",
    boxShadow: theme === "light"
      ? "0 24px 64px rgba(0,0,0,0.15)"
      : "0 24px 64px rgba(0,0,0,0.5)",
    border: theme === "light"
      ? "1px solid rgba(226,232,240,0.8)"
      : "1px solid rgba(255,255,255,0.08)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "28px",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: "700",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    letterSpacing: "-0.3px",
  },
  closeButton: {
    background: theme === "light" ? "rgba(0,0,0,0.05)" : "rgba(255,255,255,0.08)",
    border: "none",
    cursor: "pointer",
    padding: "6px",
    borderRadius: "8px",
    color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  input: {
    width: "100%",
    padding: "12px 16px",
    borderRadius: "10px",
    border: theme === "light" ? "1.5px solid #e2e8f0" : "1.5px solid rgba(255,255,255,0.12)",
    background: theme === "light" ? "#f8fafc" : "rgba(255,255,255,0.05)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: "14px",
    marginBottom: "24px",
    outline: "none",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
  },
  modalButtons: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
  },
  cancelButton: {
    background: theme === "light" ? "#f1f5f9" : "rgba(255,255,255,0.08)",
    color: theme === "light" ? "#475569" : "rgba(255,255,255,0.8)",
    border: "none",
    borderRadius: "10px",
    padding: "10px 22px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
  },
  submitButton: {
    background: "linear-gradient(135deg, #10b981, #059669)",
    color: "white",
    border: "none",
    borderRadius: "10px",
    padding: "10px 22px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
  },
  card: {
    background: theme === "light"
      ? "#ffffff"
      : "rgba(15, 23, 42, 0.6)",
    backdropFilter: "blur(20px)",
    border: theme === "light"
      ? "1px solid rgba(226,232,240,0.8)"
      : "1px solid rgba(255,255,255,0.07)",
    borderRadius: "20px",
    padding: "28px",
    marginBottom: "24px",
    boxShadow: theme === "light"
      ? "0 4px 24px rgba(0,0,0,0.06)"
      : "0 4px 24px rgba(0,0,0,0.3)",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    margin: "0 0 24px 0",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    letterSpacing: "-0.3px",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "320px 1fr",
    gap: "20px",
    alignItems: "start",
  },
  companyList: {
    maxHeight: "75vh",
    overflowY: "auto",
    paddingRight: "4px",
  },
  companyCard: (isSelected) => ({
    padding: "14px 16px",
    border: isSelected
      ? "2px solid #2e7cba"
      : theme === "light"
        ? "1.5px solid #e8edf3"
        : "1.5px solid rgba(255,255,255,0.08)",
    borderRadius: "12px",
    marginBottom: "8px",
    background: isSelected
      ? theme === "light"
        ? "linear-gradient(135deg, rgba(46,124,186,0.08), rgba(46,124,186,0.04))"
        : "linear-gradient(135deg, rgba(46,124,186,0.25), rgba(46,124,186,0.12))"
      : theme === "light"
        ? "#fafbfc"
        : "rgba(255,255,255,0.03)",
    cursor: "pointer",
    transition: "all 0.2s cubic-bezier(0.4,0,0.2,1)",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    boxShadow: isSelected
      ? "0 0 0 0px #2e7cba"
      : "none",
  }),
  companyName: {
    fontSize: "14px",
    fontWeight: "600",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    marginBottom: "2px",
    lineHeight: 1.3,
  },
  companyStatus: (isActive) => ({
    fontSize: "11px",
    color: isActive ? "#10b981" : "#f87171",
    display: "flex",
    alignItems: "center",
    gap: "3px",
    fontWeight: "500",
  }),
  permissionsContainer: {
    background: theme === "light"
      ? "#fafbfc"
      : "rgba(255,255,255,0.02)",
    border: theme === "light"
      ? "1.5px solid #e8edf3"
      : "1.5px solid rgba(255,255,255,0.07)",
    borderRadius: "16px",
    padding: "28px",
    minHeight: "400px",
  },
  sectionTitle: {
    fontSize: "13px",
    fontWeight: "700",
    color: theme === "light" ? "#2e7cba" : "rgba(46,124,186,0.9)",
    marginBottom: "12px",
    marginTop: "28px",
    paddingBottom: "8px",
    borderBottom: theme === "light"
      ? "1px solid rgba(46,124,186,0.15)"
      : "1px solid rgba(46,124,186,0.2)",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
  },
  permissionItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "11px 14px",
    marginBottom: "6px",
    borderRadius: "10px",
    background: theme === "light"
      ? "#ffffff"
      : "rgba(255,255,255,0.04)",
    border: theme === "light"
      ? "1px solid rgba(226,232,240,0.6)"
      : "1px solid rgba(255,255,255,0.05)",
    transition: "background 0.15s",
  },
  permissionLabel: {
    fontSize: "13.5px",
    fontWeight: "500",
    color: theme === "light" ? "#374151" : "rgba(255,255,255,0.88)",
  },
  toggle: (isEnabled) => ({
    width: "44px",
    height: "24px",
    borderRadius: "12px",
    background: isEnabled
      ? "#2e7cba"
      : theme === "light"
        ? "#d1d5db"
        : "rgba(255,255,255,0.18)",
    position: "relative",
    cursor: "pointer",
    transition: "background 0.25s",
    flexShrink: 0,
    boxShadow: isEnabled ? "0 0 0 3px rgba(46,124,186,0.2)" : "none",
  }),
  toggleKnob: (isEnabled) => ({
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    background: "#ffffff",
    position: "absolute",
    top: "3px",
    left: isEnabled ? "23px" : "3px",
    transition: "left 0.25s cubic-bezier(0.4,0,0.2,1)",
    boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
  }),
  button: {
    background: "linear-gradient(135deg, #2e7cba 0%, #1e5f8f 100%)",
    color: "white",
    border: "none",
    borderRadius: "10px",
    padding: "10px 20px",
    fontSize: "13.5px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    boxShadow: "0 4px 12px rgba(46,124,186,0.3)",
    letterSpacing: "0.1px",
  },
  emptyState: {
    textAlign: "center",
    padding: "80px 20px",
    color: theme === "light" ? "#94a3b8" : "rgba(255,255,255,0.4)",
  },
  message: (type) => ({
    padding: "14px 16px",
    borderRadius: "10px",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    fontWeight: "500",
    background: type === 'success'
      ? "rgba(16,185,129,0.08)"
      : type === 'error'
        ? "rgba(239,68,68,0.08)"
        : "rgba(251,191,36,0.08)",
    border: `1px solid ${type === 'success' ? "rgba(16,185,129,0.3)" : type === 'error' ? "rgba(239,68,68,0.3)" : "rgba(251,191,36,0.3)"}`,
    color: type === 'success'
      ? "#059669"
      : type === 'error'
        ? "#dc2626"
        : "#d97706",
  }),
  splashCard: {
    background: theme === "light"
      ? "rgba(46,124,186,0.03)"
      : "rgba(46,124,186,0.08)",
    border: theme === "light"
      ? "1.5px solid rgba(46,124,186,0.15)"
      : "1.5px solid rgba(46,124,186,0.2)",
    borderRadius: "14px",
    padding: "20px",
    marginBottom: "20px",
  },
  splashHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "16px",
    gap: "12px",
  },
  splashPreview: {
    width: "100%",
    maxHeight: "180px",
    objectFit: "contain",
    borderRadius: "10px",
    background: theme === "light" ? "#ffffff" : "rgba(15,23,42,0.6)",
    border: theme === "light"
      ? "1px solid rgba(226,232,240,0.8)"
      : "1px solid rgba(255,255,255,0.08)",
    padding: "8px",
    boxSizing: "border-box",
  },
  splashInputRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
  },
  splashInput: {
    width: "100%",
    padding: "10px 12px",
    borderRadius: "8px",
    border: theme === "light"
      ? "1.5px solid #e2e8f0"
      : "1.5px solid rgba(255,255,255,0.1)",
    background: theme === "light" ? "#ffffff" : "rgba(15,23,42,0.5)",
    color: theme === "light" ? "#0f172a" : "#ffffff",
    fontSize: "13px",
    outline: "none",
    boxSizing: "border-box",
  },
  iconContainer: {
    marginTop: "20px",
    paddingTop: "16px",
    borderTop: theme === "light"
      ? "1px solid rgba(46,124,186,0.1)"
      : "1px solid rgba(255,255,255,0.07)",
  },
  iconHeaderRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  iconTitle: (t) => ({
    fontSize: "14px",
    fontWeight: "600",
    color: t === "light" ? "#0f172a" : "#ffffff",
    margin: 0,
  }),
  iconSubtitle: (t) => ({
    fontSize: "12px",
    color: t === "light" ? "#64748b" : "rgba(255,255,255,0.6)",
    margin: "3px 0 0 0",
  }),
  iconPreview: {
    width: "68px",
    height: "68px",
    borderRadius: "14px",
    background: theme === "light" ? "#ffffff" : "rgba(15,23,42,0.6)",
    border: theme === "light"
      ? "1px solid #e2e8f0"
      : "1px solid rgba(255,255,255,0.1)",
    padding: "10px",
    objectFit: "contain",
    boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
  },
  iconPlaceholder: (t) => ({
    width: "68px",
    height: "68px",
    borderRadius: "14px",
    border: "1.5px dashed rgba(148,163,184,0.4)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    fontSize: "11px",
    color: t === "light" ? "#94a3b8" : "rgba(255,255,255,0.4)",
    background: t === "light" ? "#f8fafc" : "rgba(15,23,42,0.3)",
  }),
  iconInputRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
  },
  iconLabel: (t) => ({
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    color: t === "light" ? "#475569" : "rgba(255,255,255,0.7)",
    marginBottom: "6px",
    textTransform: "uppercase",
    letterSpacing: "0.4px",
  }),
  iconHint: (t) => ({
    fontSize: "11.5px",
    color: t === "light" ? "#94a3b8" : "rgba(255,255,255,0.4)",
    marginTop: "10px",
  }),
  splashActions: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    alignItems: "center",
    marginTop: "16px",
  },
  secondaryButton: {
    background: theme === "light" ? "rgba(226,232,240,0.7)" : "rgba(255,255,255,0.07)",
    color: theme === "light" ? "#475569" : "rgba(255,255,255,0.75)",
    border: theme === "light" ? "1px solid #e2e8f0" : "1px solid rgba(255,255,255,0.1)",
    borderRadius: "8px",
    padding: "9px 16px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "7px",
  },
});